import { BoxItWhiteLogo } from '@application/Interfaces/Images/BoxItWhiteLogo'
import { BoxItColorLogo } from '@src/Application/Interfaces/Images/BoxItColorLogo'

export const BoxIt4meLogos = {
    logoWhite: BoxItWhiteLogo,
    logoColor: BoxItColorLogo,
}
